let trustedResourceUrlFilter = ($sce) => {
    'ngInject';
    return (input) => {
        return $sce.trustAsResourceUrl(input);
    };
};

export default trustedResourceUrlFilter;